import { render, staticRenderFns } from "./workTypeStatus.vue?vue&type=template&id=54681a22&"
import script from "./workTypeStatus.vue?vue&type=script&lang=js&"
export * from "./workTypeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports